import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { map } from 'rxjs';
import { PICFLOW_STORYBLOK } from '../picflow-storyblok';

export const WEBSITE_HEADER_SLUG = 'headers/website-header';
export const WEBSITE_FOOTER_SLUG = 'footers/website-footer';

/** Shared Storyblok chrome. Prefetch starts the fetches; resolvers reuse the in-flight cache. */
@Injectable({
  providedIn: 'root',
})
export class WebsiteChromeService {
  private readonly storyblok = inject(PICFLOW_STORYBLOK);

  prefetch(route?: ActivatedRouteSnapshot): void {
    this.header(route).subscribe();
    this.footer(route).subscribe();
  }

  header(route?: ActivatedRouteSnapshot) {
    return this.storyblok
      .getStory(WEBSITE_HEADER_SLUG, route)
      .pipe(map(resp => (resp && resp.story) || (false as const)));
  }

  footer(route?: ActivatedRouteSnapshot) {
    return this.storyblok
      .getStory(WEBSITE_FOOTER_SLUG, route)
      .pipe(map(resp => (resp && resp.story) || (false as const)));
  }
}

export const prefetchWebsiteChromeGuard: CanActivateFn = route => {
  inject(WebsiteChromeService).prefetch(route);
  return true;
};
